/* Moskera — "Enregistrer pour plus tard" (cœur favoris)
   Sauvegarde / retire une configuration dans le compte client via l'App Proxy
   (/apps/moskera/configs). Aucune dépendance, pattern IIFE comme le thème.
   Config injectée par le snippet mk-wishlist-init : window.MKWishlist. */
(function () {
  "use strict";
  var CFG = window.MKWishlist || {};
  var BASE = CFG.proxyBase || "/apps/moskera";
  var LOGGED_IN = !!CFG.loggedIn;
  var savedMap = null; // Map signature -> configId (configs déjà sauvegardées)

  // Exposé pour réutilisation (ex. configurateur sur-mesure).
  window.MKWishlistToast = function (m, t) {
    toast(m, t);
  };

  // --- utils ---------------------------------------------------------------
  function parseDims(s) {
    if (!s) return {};
    var m = String(s)
      .replace(",", ".")
      .match(/(\d+(?:\.\d+)?)\s*[x×X]\s*(\d+(?:\.\d+)?)/);
    return m ? { w: parseFloat(m[1]), h: parseFloat(m[2]) } : {};
  }
  function mapType(t, props) {
    var s = ((props && props.Application) || t || "").toLowerCase();
    if (s.indexOf("porte") > -1) return "porte";
    if (s.indexOf("fen") > -1) return "fenetre";
    if (
      s.indexOf("grande") > -1 ||
      s.indexOf("baie") > -1 ||
      s.indexOf("xl") > -1
    )
      return "grande_taille";
    if (
      s.indexOf("piece") > -1 ||
      s.indexOf("pièce") > -1 ||
      s.indexOf("rechange") > -1 ||
      s.indexOf("adhésif") > -1 ||
      s.indexOf("adhesif") > -1
    )
      return "piece_detachee";
    return "autre";
  }
  function mapShape(f) {
    var s = (f || "").toLowerCase();
    if (s.indexOf("cintr") > -1) return "cintree";
    if (s.indexOf("asym") > -1) return "asymetrique";
    if (s.indexOf("circ") > -1 || s.indexOf("rond") > -1) return "circulaire";
    return s ? "standard" : undefined;
  }
  // Signature stable d'une config (pour retrouver l'état rouge + l'id).
  function signature(variantId, props) {
    var dims = (props && props.Dimensions) || "";
    return String(variantId || "") + "|" + dims;
  }

  // --- toast ---------------------------------------------------------------
  function toast(msg, type) {
    var el = document.createElement("div");
    el.className = "mk-toast" + (type ? " mk-toast--" + type : "");
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      el.classList.add("mk-toast--show");
    });
    setTimeout(function () {
      el.classList.remove("mk-toast--show");
      setTimeout(function () {
        el.remove();
      }, 300);
    }, 3000);
  }

  // --- données du bouton ---------------------------------------------------
  function readData(btn) {
    var props = {};
    try {
      var parsed = JSON.parse(btn.getAttribute("data-properties") || "{}");
      if (parsed && typeof parsed === "object") props = parsed;
    } catch (e) {}
    if (Array.isArray(props)) {
      var o = {};
      props.forEach(function (p) {
        if (p && p[0] != null) o[p[0]] = p[1];
      });
      props = o;
    }
    var variantId = btn.getAttribute("data-variant");
    var quantity = parseInt(btn.getAttribute("data-qty") || "1", 10) || 1;

    // Page produit : lire la variante / quantité / propriétés réellement
    // sélectionnées dans le formulaire au moment du clic.
    if (btn.getAttribute("data-mk-from-form")) {
      var form = btn.closest(
        "form[action*='/cart/add'], product-form form, form",
      );
      if (form) {
        var idEl = form.querySelector("[name='id']");
        if (idEl && idEl.value) variantId = idEl.value;
        var qtyEl = form.querySelector("[name='quantity']");
        if (qtyEl && qtyEl.value) quantity = parseInt(qtyEl.value, 10) || 1;
        var propEls = form.querySelectorAll("[name^='properties[']");
        Array.prototype.forEach.call(propEls, function (el) {
          var m = el.name.match(/^properties\[(.+)\]$/);
          if (m && el.value) props[m[1]] = el.value;
        });
      }
    }

    var clean = {};
    Object.keys(props).forEach(function (k) {
      if (k.charAt(0) !== "_") clean[k] = props[k];
    });
    var priceAttr = btn.getAttribute("data-price");
    return {
      variantId: variantId,
      quantity: quantity,
      title: btn.getAttribute("data-title") || "",
      type: btn.getAttribute("data-type") || "",
      price: priceAttr ? parseInt(priceAttr, 10) : null,
      properties: clean,
    };
  }

  function buildPayload(d) {
    var props = d.properties || {};
    var dims = parseDims(props.Dimensions);
    var name = d.title || "Configuration";
    if (props.Dimensions) name += " — " + props.Dimensions;
    return {
      name: name,
      productType: mapType(d.type, props),
      shape: mapShape(props.Forme),
      widthCm: dims.w,
      heightCm: dims.h,
      color: props.Couleur,
      estimatedPrice:
        d.price != null
          ? { amount: d.price / 100, currencyCode: CFG.currency || "EUR" }
          : undefined,
      variantId: d.variantId != null ? String(d.variantId) : undefined,
      quantity: d.quantity || 1,
      properties: props,
    };
  }

  // --- API -----------------------------------------------------------------
  function saveConfig(payload) {
    return fetch(BASE + "/configs", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json().then(function (j) {
        return { ok: r.ok && j && j.ok, data: j };
      });
    });
  }
  function removeConfig(id) {
    return fetch(BASE + "/configs?id=" + encodeURIComponent(id), {
      method: "DELETE",
    }).then(function (r) {
      return r.json().then(function (j) {
        return { ok: r.ok && j && j.ok };
      });
    });
  }
  function loadSaved() {
    if (savedMap) return Promise.resolve(savedMap);
    return fetch(BASE + "/configs", { headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (j) {
        savedMap = new Map();
        (j.configs || []).forEach(function (c) {
          savedMap.set(signature(c.variantId, c.properties), c.id);
        });
        return savedMap;
      })
      .catch(function () {
        savedMap = new Map();
        return savedMap;
      });
  }

  // --- UI ------------------------------------------------------------------
  function setHeart(btn, active, configId) {
    btn.classList.toggle("mk-heart--active", !!active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
    if (active && configId) btn.setAttribute("data-config-id", configId);
    if (!active) btn.removeAttribute("data-config-id");
  }

  function onHeartClick(btn) {
    if (btn.getAttribute("data-busy")) return;
    if (!LOGGED_IN) {
      toast(
        CFG.msgLogin || "Connectez-vous pour sauvegarder une configuration.",
        "info",
      );
      return;
    }
    var active = btn.classList.contains("mk-heart--active");
    var payload = buildPayload(readData(btn));
    var sig = signature(payload.variantId, payload.properties);
    btn.setAttribute("data-busy", "1");

    if (active) {
      // Retrait des favoris (toggle off).
      var id = btn.getAttribute("data-config-id");
      var op = id ? removeConfig(id) : Promise.resolve({ ok: false });
      op.then(function (res) {
        btn.removeAttribute("data-busy");
        if (res.ok) {
          setHeart(btn, false);
          if (savedMap) savedMap.delete(sig);
          toast(CFG.msgRemoved || "Retiré de votre liste de favoris.", "info");
        } else {
          toast("Action impossible, réessayez.", "error");
        }
      }).catch(function () {
        btn.removeAttribute("data-busy");
        toast("Action impossible, réessayez.", "error");
      });
    } else {
      // Ajout aux favoris.
      saveConfig(payload)
        .then(function (res) {
          btn.removeAttribute("data-busy");
          if (res.ok) {
            var cid = res.data && res.data.config && res.data.config.id;
            setHeart(btn, true, cid);
            if (savedMap) savedMap.set(sig, cid);
            toast(
              CFG.msgSaved || "Article sauvegardé pour plus tard.",
              "success",
            );
          } else {
            toast("Impossible d'enregistrer, réessayez.", "error");
          }
        })
        .catch(function () {
          btn.removeAttribute("data-busy");
          toast("Impossible d'enregistrer, réessayez.", "error");
        });
    }
  }

  function initHearts() {
    var hearts = document.querySelectorAll(
      "[data-mk-heart]:not([data-mk-bound])",
    );
    if (!hearts.length) return;
    Array.prototype.forEach.call(hearts, function (btn) {
      btn.setAttribute("data-mk-bound", "1");
    });
    if (LOGGED_IN) {
      loadSaved().then(function (map) {
        Array.prototype.forEach.call(hearts, function (btn) {
          var d = readData(btn);
          var sig = signature(d.variantId, d.properties);
          if (map.has(sig)) setHeart(btn, true, map.get(sig));
        });
      });
    }
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-mk-heart]");
    if (btn) {
      e.preventDefault();
      onHeartClick(btn);
    }
  });

  if (document.readyState !== "loading") initHearts();
  else document.addEventListener("DOMContentLoaded", initHearts);
  document.addEventListener("cart:refresh", initHearts);
  document.addEventListener("cart:updated", initHearts);
})();
